module.exports = __webpack_public_path__ + "static/img/u307.00cea7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u307.png
// module id = hVbk
// module chunks = 1